import { RegexEnum } from '../../libs/enums';
import { mustBeLessThan, mustBeMoreThan, mustMatchFormat } from '../../libs/validators';

export const inputPhoneConfig = {
  description: 'Exemple : (+33) X XX XX XX XX ou 0X XX XX XX XX',
  label: 'Numéro de téléphone',
  name: 'phone',
  type: 'tel',
  validators: {
    format: [
      mustBeMoreThan(3),
      mustBeLessThan(30),
      mustMatchFormat(
        RegexEnum.PHONE,
        'Le format du numéro téléphone saisie n’est pas valide. Le format attendu est : (+33) 2 43 55 55 55 ou 01 22 33 44 55',
      ),
    ],
    submit: undefined,
  },
};
